<template>
    <div>
        <section class="l-section l-section--hero">
            <div class="l-grid">
                <div class="l-grid__row">
                    <div class="w-full sm:w-1/2 md:w-5/12">
                        <h1 class="l-section__title | t-t1-serif">
                            {{ page.content.header_title }}
                        </h1>

                        <Formular
                            :action="formAction"
                            :fields="formInputs"
                        ></Formular>
                    </div>

                    <div
                        v-if="restaurant && markers"
                        class="p-map | w-full sm:w-1/2 --no-gutter"
                    >

                        <GmapMap
                            ref="mapRef"
                            :center="{ lat: 46.7604948, lng: -71.3640384 }"
                            :zoom="16"
                            :options="map.options"
                            class="o-map"
                        >
                            <GmapCustomMarker
                                v-for="(marker, i) in markers"
                                :key="i"
                                :marker="marker.position"
                                class="o-map__marker"
                                @click.native="toggleInfo(marker, i)"
                            >
                                <Icon icon="logo-icon" size="xs" />

                            </GmapCustomMarker>
                            <GmapInfoWindow
                                v-if="map.info"
                                :position="map.info.position"
                                :opened="true"
                                class="o-map-info"
                            >
                                <header class="o-map-info__header">
                                    <Icon icon="logo-icon" size="xs" />
                                    <h3 class="o-map-info__title">{{ map.info.data.name }}</h3>
                                </header>
                                <p class="o-map-info__address" v-html="map.info.data.address"></p>
                                <a
                                    :href="toPhoneNumber(map.info.data.phone)"
                                    :title="`Appeler ${map.info.data.name}`"
                                    class="o-map-info__phone"
                                    target="blank"
                                >{{ map.info.data.phone }}</a>
                            </GmapInfoWindow>
                        </GmapMap>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>/* eslint-disable */

    import Btn from 'components/Btn'
    import Icon from 'components/Icon'
    import Formular from 'components/Formular'

    import Meta from 'mixins/meta'

    import { mapStyles } from 'vendors/google-maps'
    import { hrefTel } from 'utils/utils'
    import merge from 'lodash/merge'

    import GmapCustomMarker from 'vue2-gmap-custom-marker';

    export default {

        name: 'Contact',
        components: {
            Btn,
            Formular,
            Icon,
            GmapCustomMarker
        },
        mixins: [ Meta ],
        props: {
            page: Object,
            site: Object
        },
        data() {
            return {
                formAction: '/actions/forms/submit',
                formInputs: [
                    {
                        name: 'firstname',
                        placeholder: 'Prénom',
                        type: 'text',
                        required: true,
                        half: true
                    },
                    {
                        name: 'lastname',
                        placeholder: 'Nom',
                        type: 'text',
                        required: true,
                        half: true
                    },
                    {
                        name: 'email',
                        placeholder: 'Adresse courriel',
                        type: 'email',
                        required: false,
                        half: false
                    },
                    {
                        name: 'message',
                        placeholder: 'Message',
                        type: 'textarea',
                        required: false,
                        half: false
                    },
                ],
                map: {
                    options: {
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: true,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUi: true,
                        styles: mapStyles
                    },
                    markers: [],
                    info: null
                }
            }
        },
        created() {
            //
        },
        computed: {

            restaurant() {

                if ( !this.site )
                    return

                return this.site.restaurant

            },
            markers() {

                if ( !this.restaurant )
                    return

                const restaurant = this.restaurant

                const _position = {
                    lat: restaurant.location.lat,
                    lng: restaurant.location.lon
                }

                const _data = {
                    name: restaurant.title,
                    address: restaurant.address,
                    phone: restaurant.phone,
                }

                const restaurantMarker = merge({position:_position}, {data:_data})

                return [restaurantMarker]

            }
        },
        methods: {

            toPhoneNumber(number) {
                return hrefTel(number)
            },

            toggleInfo(marker) {
                this.map.info = marker;
                //console.log('toggleInfo', this.map.info)
            }
        },
        watch: {
            markers(markers) {

                if ( markers.length === 1) {
                    this.toggleInfo( markers[0] )
                }
            }
        },
        mounted() {
/*
            this.$nextTick(function () {

                // FitBounds
                this.$refs.mapRef.$mapPromise.then((map) => {
                    //let markers = markers
                    let bounds = map.getBounds()
                    //console.log( map )
                    map.fitBounds(bounds)
                    map.panToBounds(bounds)
                })

            })
*/
        }
    }
</script>

<style lang="scss">

    // Map
    .o-map {
        width: 100%;
        height: 50vh;

        .gm-style {

            &,
            .gm-style-iw {
                font-size: inherit;
                box-shadow: none;
            }

            // Infobox
            .gm-style-iw-c {
                border-radius: 1.2em 0 0 0;
                transform: translate(calc(-1em - 12px), calc(-1em - 12px));

                // Close btn
                button { display: none !important; }
            }

            // Infobox inner
            .gm-style-iw-d {
                padding: .25em 1em .25em .25em;
            }

            // Indicator
            .gm-style-iw-t:after { display: none; }
        }
    }

    // Marker
    .o-map-marker {}

    // Info window
    //.o-map-info {}

    .o-map-info__phone,
    .o-map-info__title,
    .o-map-info__address {
        @apply font-sans;
    }

    .o-map-info__header {
        display: flex;
        align-items: center;

        .o-icon {
            margin-right: 1.5em;
        }
    }

    .o-map-info__title {
        font-size: 1em;
        font-weight: 700;
    }

    .o-map-info__phone,
    .o-map-info__address {
        color: $color-dark;
        font-size: .75em;
        font-weight: 400;
    }

    .o-map-info__address {
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .o-map-info__phone {}

</style>
